/**
 * @module Helpers/Cart
 * @desc Cart Helpers
 */

import type { Cart } from 'core/domains';
import { REQUEST_STATE } from 'core/use-cases/utilities';
import { actions } from 'core/use-cases/cart/actions';

type RequestAction =
  | ReturnType<typeof actions.itemAddFetch.request>
  | ReturnType<typeof actions.itemDeleteFetch.request>
  | ReturnType<typeof actions.itemUpdateFetch.request>
  | ReturnType<typeof actions.itemAddFetch.failure>
  | ReturnType<typeof actions.itemDeleteFetch.failure>
  | ReturnType<typeof actions.itemUpdateFetch.failure>;

/**
 * Function responsible for updating the quantity of the item
 *
 */

export function updateItemQuantity(state: Cart, action: RequestAction) {
  const {
    data: { items },
  } = state;

  const hasError = action.type.includes(REQUEST_STATE.FAILURE);

  const payload = hasError ? action.meta?.payload : action.payload;

  if (payload) {
    const { productCode, quantity } = payload as Cart['data']['items'][number];

    const itemsCart = items?.map((item) => {
      if (item.productCode === productCode) {
        return {
          ...item,
          quantity: hasError ? item.previousQuantity : quantity,
          ...(!hasError && { previousQuantity: item.quantity }),
        };
      }

      return item;
    });

    state.data = {
      ...state.data,
      items: itemsCart,
    };
  }
}
